
module.exports.ENVIRONMENTS = {
	DEVELOPMENT: 'development',
	PRODUCTION: 'production',
	TEST: 'test',
};
